<template>
  <div>
    <v-expansion-panels focusable multiple v-if="chek">
      <v-expansion-panel v-for="dat in dataObr" :key="dat.NameProg" class="my-3">
        <v-expansion-panel-header color="#F1F4FB">
          <v-col cols="2">Образовательная программа:</v-col>
          <v-col>{{dat.NameProg}}</v-col>
        </v-expansion-panel-header>
        <v-expansion-panel-content color="#F1F4FB">
          <v-row>
            <v-col cols="2">Формируемые компитенции:</v-col>
            <v-col>
              <div
                v-for="k in dat.komp"
                :key="k"
                class="d-inline text-decoration-underline pr-2"
              >{{k}};</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">Продолжительность обучения</v-col>
            <v-col>{{dat.dateOb}}</v-col>
          </v-row>
          <v-row>
            <v-col cols="2">Количество студентов:</v-col>
            <v-col>{{dat.kolStud}}</v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-else>
      <v-row class="ma-0">
        <v-col align="center">
          <p class="head">Данных нет</p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    dataObr: [],
  }),
  created() {
    this.dataObr = this.$ls.get("obrprog");
  },
  computed: {
    chek() {
      if (this.$ls.get("obrprog") != undefined) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>


<style>
p.head {
  letter-spacing: 4px;
  word-spacing: 4px;
  font-size: 1.3vw;
}
</style>